/**
 * Returns true when running in a test execution context (Vitest, Playwright, or Node test environment).
 * @returns {boolean}
 */
export default function isTest(): boolean {
  try {
    // Vitest
    if (!!process?.env?.VITEST || !!process?.env?.VITEST_POOL_ID || import.meta['vitest']) {
      return true
    }

    // Playwright
    if (window['Playwright'] !== undefined) {
      return true
    }

    // Node
    if (process?.env?.NODE_ENV === 'test') {
      return true
    }

    return false
  } catch (_) {
    return false
  }
}
